var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86928 8.99547L7.91806 7.04425C7.8205 6.9662 7.70343 6.90766 7.58636 6.90766H7.27416C7.80099 6.22473 8.1327 5.3662 8.1327 4.4101C8.1327 2.18571 6.29855 0.351562 4.07416 0.351562C1.83026 0.351562 0.015625 2.18571 0.015625 4.4101C0.015625 6.654 1.83026 8.46864 4.07416 8.46864C5.01075 8.46864 5.86928 8.15644 6.57172 7.6101V7.94181C6.57172 8.05888 6.61075 8.17595 6.70831 8.27351L8.64002 10.2052C8.83514 10.4003 9.12782 10.4003 9.30343 10.2052L9.84977 9.65888C10.0449 9.48327 10.0449 9.19059 9.86928 8.99547ZM4.07416 6.90766C2.6888 6.90766 1.5766 5.79546 1.5766 4.4101C1.5766 3.04425 2.6888 1.91254 4.07416 1.91254C5.44002 1.91254 6.57172 3.04425 6.57172 4.4101C6.57172 5.79546 5.44002 6.90766 4.07416 6.90766Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifying);
export default __webpack_public_path__ + "static/media/magnifying.fddefedaad88314386ac0471066f222a.svg";
export { ForwardRef as ReactComponent };